import { useEffect, useRef } from 'react';
import { trackStepStarted } from '../../../shared/analytics';
import { getMatcherFormName } from './MatcherGetFormName';

// Fires once per mount; the ref keeps StrictMode's double-invoked effect from sending twice.
function useTrackMatcherStepStarted(
  step: number,
  stepName: string,
  stepLabel: string,
  enabled = true
) {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!enabled || hasTracked.current) return;
    hasTracked.current = true;
    trackStepStarted({
      step,
      step_name: stepName,
      step_label: stepLabel,
      form_name: getMatcherFormName()
    });
  }, [enabled, step, stepName, stepLabel]);
}

export { useTrackMatcherStepStarted };
